import {
  FETCH_CARDS_RATES_REQUEST,
  FETCH_CARDS_RATES_SUCCESS,
  FETCH_CARDS_RATES_FAILURE,
} from 'actionTypes';

import createReducer from './createReducer';

export const initialState = {};

const cardsRates = createReducer(initialState, {
  [FETCH_CARDS_RATES_REQUEST]: (state, { payload: { dateKey } }) => ({
    ...state,
    [dateKey]: {
      ...(state[dateKey] || {}),
      entities: {
        ...((state[dateKey] && state[dateKey].entities) || {
          all: [],
          visa: [],
          mc: [],
        }),
      },
      isFetching: true,
      isInitialized: false,
    },
  }),
  [FETCH_CARDS_RATES_SUCCESS]: (state, { payload: { dateKey, entities } }) => ({
    ...state,
    [dateKey]: {
      ...(state[dateKey] || {}),
      entities: {
        ...((state[dateKey] && state[dateKey].entities) || {
          all: [],
          visa: [],
          mc: [],
        }),
        ...entities,
      },
      isFetching: false,
      isInitialized: true,
    },
  }),
  [FETCH_CARDS_RATES_FAILURE]: (state, { payload: { dateKey } }) => ({
    ...state,
    [dateKey]: {
      ...(state[dateKey] || {}),
      entities: {
        ...((state[dateKey] && state[dateKey].entities) || {
          all: [],
          visa: [],
          mc: [],
        }),
      },
      isFetching: false,
      isInitialized: true,
    },
  }),
});

export default cardsRates;
